import {featureIcons} from "../../../assets/icons/ProblemIcons";
import {ProblemFeatureType} from "../../../config/enums";
import {featureTheme} from "../../../config/themes/feature-theme";
import {ViewModelProps} from "../../../config/type";

export enum QuestionCategoryType {
  FOUNDATIONS = "MUST_DO",
  WORKBOOK = "FAQ",
  AI_PICKS = "SUGGESTED",
  PAST_YEARS = "PYQ",
}
export const getQuestionCategoryType = (category: string | null) => {
  switch (category) {
    case QuestionCategoryType.FOUNDATIONS:
      return QuestionCategoryType.FOUNDATIONS;
    case QuestionCategoryType.AI_PICKS:
      return QuestionCategoryType.AI_PICKS;
    case QuestionCategoryType.PAST_YEARS:
      return QuestionCategoryType.PAST_YEARS;
    case QuestionCategoryType.WORKBOOK:
      return QuestionCategoryType.WORKBOOK;
    default:
      return QuestionCategoryType.FOUNDATIONS;
  }
};

export type QuestionCategoryDetailProps = {
  type: QuestionCategoryType;
  routeId: string;
  viewModel: ViewModelProps;
  isDisabled?: boolean;
};

export const questionCategoryDetails: Record<
  QuestionCategoryType,
  QuestionCategoryDetailProps
> = {
  [QuestionCategoryType.FOUNDATIONS]: {
    type: QuestionCategoryType.FOUNDATIONS,
    routeId: "foundations",
    viewModel: {
      id: QuestionCategoryType.FOUNDATIONS,
      name: "Foundations",
      description: "Selected Problems",
      color: featureTheme[ProblemFeatureType.MustDo],
      icon: featureIcons[ProblemFeatureType.MustDo],
      image: "/mockTest/diamond-hand.svg",
    },
  },
  [QuestionCategoryType.WORKBOOK]: {
    type: QuestionCategoryType.WORKBOOK,
    routeId: "workbook",
    viewModel: {
      id: QuestionCategoryType.WORKBOOK,
      name: "Workbook",
      description: "COMPLETE SET",
      color: featureTheme[ProblemFeatureType.Random],
      icon: featureIcons[ProblemFeatureType.Random],
      image: "/mockTest/chapter-wise-mock-v3.png",
    },
  },
  [QuestionCategoryType.AI_PICKS]: {
    type: QuestionCategoryType.AI_PICKS,
    routeId: "ai-picks",
    viewModel: {
      id: QuestionCategoryType.AI_PICKS,
      name: "AI Picks",
      description: "SUGGESTED FOR YOU",
      color: featureTheme[ProblemFeatureType.Suggested],
      icon: featureIcons[ProblemFeatureType.Suggested],
      image: "/mockTest/adaptive-learning.png",
    },
  },
  [QuestionCategoryType.PAST_YEARS]: {
    type: QuestionCategoryType.PAST_YEARS,
    routeId: "past-years",
    viewModel: {
      id: QuestionCategoryType.PAST_YEARS,
      name: "Past Years",
      description: "Build confidence",
      color: featureTheme[ProblemFeatureType.Pyqs],
      icon: featureIcons[ProblemFeatureType.Pyqs],
      image: "/mockTest/previous-year-papers-v4.png",
    },
  },
};

export const getQuestionCategoryItemList = (
  selectedId: QuestionCategoryType,
) => {
  return Object.entries(questionCategoryDetails).map(([key, value]) => ({
    id: key as any,
    viewModel: value.viewModel,
    isSelected: key === selectedId,
  }));
};
